import PropTypes from 'prop-types';
import cssVars from 'src/common/styles/variables';

/* eslint-disable max-len */
const HeartEmptyIcon = ({
  width,
  height,
  viewBox,
  onClick,
  className,
  fill,
  dataTestId,
}) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox || '0 0 19 17'}
    fill={fill || cssVars['--secondary-color-5']}
    className={className}
    data-testid={dataTestId}
    onClick={onClick}
  >
    <path d="M4.8 2.5a2 2 0 0 1 1.4.6l1.2 1.3 1.8 1.9L11 4.4l1.2-1.3a2 2 0 0 1 1.5-.6 2 2 0 0 1 1.4.6 3 3 0 0 1 0 4.2l-5.9 6-5.9-6a3 3 0 0 1 0-4.2 2 2 0 0 1 1.5-.6m0-2.5a4.5 4.5 0 0 0-3.3 1.4 5.5 5.5 0 0 0 0 7.6l7.3 7.7a.5.5 0 0 0 .8 0L16.9 9a5.5 5.5 0 0 0 0-7.6 4.5 4.5 0 0 0-6.5 0L9.2 2.7 8 1.4A4.5 4.5 0 0 0 4.7 0z" />
  </svg>
);

HeartEmptyIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  viewBox: PropTypes.string,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  onClick: PropTypes.func,
  fill: PropTypes.string,
};

export default HeartEmptyIcon;
